
<section>
  <article>
    {{ config.title }}
  </article>
  <aside *ngIf="config.action as action" (click)="actionClicked()">
    &nbsp;{{ action.label }}
  </aside>
</section>
